import type { PostgrestError } from "@supabase/supabase-js";

export function throwIfError(error: PostgrestError | null): void {
  if (error) throw new Error(error.message);
}

export function assertData<T>(data: T | null, message = "No data returned"): T {
  if (data === null) throw new Error(message);
  return data;
}

